/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskPolicyEvalReview,
  RiskPolicyEvalReview$inboundSchema,
} from "./riskpolicyevalreview.js";

export type ListRiskEvalReviewsResult = {
  /**
   * The active review set for the policy.
   */
  reviews: Array<RiskPolicyEvalReview>;
};

/** @internal */
export const ListRiskEvalReviewsResult$inboundSchema: z.ZodMiniType<
  ListRiskEvalReviewsResult,
  unknown
> = z.object({
  reviews: z.array(RiskPolicyEvalReview$inboundSchema),
});

export function listRiskEvalReviewsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRiskEvalReviewsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRiskEvalReviewsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRiskEvalReviewsResult' from JSON`,
  );
}
